var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStoreBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 119.66 40",
    role: "img",
    "aria-label": "Download on the App Store",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Download on the App Store") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 118.66,
    height: 39,
    rx: 6.5,
    ry: 6.5,
    fill: "#000000",
    stroke: "#A6A6A6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.85 19.69c-.02-2.34 1.91-3.48 2-3.53-1.09-1.6-2.79-1.81-3.39-1.83-1.43-.15-2.81.85-3.54.85-.74 0-1.86-.84-3.07-.81-1.55.02-3.01.93-3.81 2.32-1.65 2.86-.42 7.07 1.16 9.39.79 1.13 1.71 2.4 2.92 2.36 1.18-.05 1.62-.76 3.05-.76 1.41 0 1.83.76 3.07.73 1.27-.02 2.07-1.14 2.84-2.28.91-1.3 1.27-2.58 1.29-2.65-.03-.01-2.46-.94-2.49-3.74-.02-2.34 1.91-3.46 2-3.52-1.09-1.6-2.79-1.81-3.39-1.83zM20.43 13.32c.65-.81 1.09-1.92.97-3.04-.94.04-2.11.65-2.79 1.45-.6.7-1.13 1.85-.99 2.93 1.06.08 2.14-.54 2.81-1.34z"
  }), /*#__PURE__*/React.createElement("text", {
    x: 33,
    y: 16,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: 7.5,
    fontWeight: 400,
    letterSpacing: 0.1
  }, "Download on the"), /*#__PURE__*/React.createElement("text", {
    x: 33,
    y: 29,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Arial, sans-serif",
    fontSize: 14.5,
    fontWeight: 600,
    letterSpacing: -0.2
  }, "App Store"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreBadge);
export default __webpack_public_path__ + "static/media/app-store-badge.0205c5792237e57b2010c37c6e3da7a2.svg";
export { ForwardRef as ReactComponent };